export default {
  getAdminProductList(state) {
    return state.productList;
  },

  getProductDetail(state) {
    return state.productInfo;
  },

  getStoreCategoryList(state) {
    return state.storeCategoryList;
  },

  getProductCategoryList(state) {
    return state.productCategoryList;
  }
};
